import { mix, toHex } from "color2k"
import { getFallbackTextColor } from "~/services/Utils"

export const getColorScales = (color: string) => {
  const lighten = (amount: number) => toHex(mix(color, "#ffffff", amount))
  const darken = (amount: number) => toHex(mix(color, "#000000", amount))

  return {
    50: lighten(0.52),
    100: lighten(0.44),
    200: lighten(0.35),
    300: lighten(0.26),
    400: lighten(0.15),
    500: color,
    600: darken(0.12),
    700: darken(0.22),
    800: darken(0.33),
    900: darken(0.45),
    text: getFallbackTextColor(color),
  }
}
